import {
	Component,
	Input,
	OnInit,
} from '@angular/core';

import { catchError, map } from 'rxjs/operators';

import { Observable, of } from 'rxjs';

import { HttpRequestResult } from 'ib/internetbank-core/utils/http-client.utils';


import { StatementDTO, StatementItemDTO } from '../statements-model';
import { StatementsService } from '../statements.service';

@Component({
	selector: 'app-statement-block',
	templateUrl: './statement-block.component.html',
	styleUrls: ['./statement-block.component.less'],
	standalone: false,
})
export class StatementBlockComponent implements OnInit {
	@Input()
	public title: string;
	@Input()
	public emptyListText: string;


	public statementData: StatementDTO;
	public userEmail = 'Нет данных';

	public getStatementData$: Observable<StatementDTO>;

	public statementData$: Observable<HttpRequestResult<StatementDTO | undefined>> = this.statementsService
		.getStatementSourceList()
		.pipe(
			map((data: StatementDTO) => {
				return HttpRequestResult.sucess(data)
			}),
			catchError(() => {
				return of(HttpRequestResult.error('Ошибка загрузки данных'));
			}),
		);

	constructor(public statementsService: StatementsService) { }

	public ngOnInit(): void {

		this.statementsService.statementSigned$.subscribe((id: number) => {
			if (
				this.statementData &&
				this.statementData.claims &&
				this.statementData.claims.length
			) {
				// не отображаем только что подписанные заявления
				this.statementData.claims = this.statementData.claims.filter((el: StatementItemDTO) => el.id !== id);
			}
		});

		this.statementsService.statementRejected$.subscribe((claim: StatementItemDTO) => {
			if (
				this.statementData &&
				this.statementData.claims &&
				this.statementData.claims.length
			) {
				this.statementData.claims = this.statementData.claims.filter(
					(el: StatementItemDTO) => el !== claim,
				);
			}
		});
	}
}
